import {useMemo} from 'react'
import {useGameStore} from '../GameStoreContext'
import {MechanicValidatorBarbarianInvasion} from '@colonist/game-mechanic-validators'
import {usePlayerValidators} from './usePlayerValidators'
import {useMapValidator} from './useMapValidator'

export const useBarbarianInvasionValidator = () => {
    const {playerValidators} = usePlayerValidators()
    const mapValidator = useMapValidator()
    const barbarianInvasionState = useGameStore((state) => state.gameState.mechanicBarbarianInvasionState)
    if(barbarianInvasionState == undefined) return undefined

    return useMemo(() => {
        const validator = new MechanicValidatorBarbarianInvasion(playerValidators, mapValidator, barbarianInvasionState)
        return validator
    }, [playerValidators, mapValidator, barbarianInvasionState])
}
